import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const apiURI = process.env.REACT_APP_API_URL

// Create an axios instance
export const axiosInstance = axios.create({
  baseURL: apiURI,
});

// Helper to get current user, waiting if necessary
const getCurrentUser = () => {
  return new Promise((resolve) => {
    const auth = getAuth();
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }
    // Wait for auth state to initialize
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

// Add a request interceptor to include the Firebase token
axiosInstance.interceptors.request.use(
  async (config) => {
    const user = await getCurrentUser();
    if (user) {
      const token = await user.getIdToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
